/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCurrency = createReactComponent("outline", "currency", "IconCurrency", [["path", { "d": "M12 12m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0", "key": "svg-0" }], ["path", { "d": "M4 4l3 3", "key": "svg-1" }], ["path", { "d": "M20 4l-3 3", "key": "svg-2" }], ["path", { "d": "M4 20l3 -3", "key": "svg-3" }], ["path", { "d": "M20 20l-3 -3", "key": "svg-4" }]]);

export { IconCurrency as default };
//# sourceMappingURL=IconCurrency.mjs.map
